export default __webpack_public_path__ + "static/FAQ_EzyMedical (MV)-5ec5a6b8c28e3e30e4296f0fdfd53632.pdf";